export default "__VITE_ASSET__0e258aa2__"